import React from 'react';
import CustomBoxTemplateGraph from '../../../components/CustomGraphTemplate';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

export const TemplateUno = () => {
    return (
        <div className='template1'>
            <CustomBoxTemplateGraph width='xl' margin={false} />
            <CustomBoxTemplateGraph width='md' margin={false} />
            <CustomBoxTemplateGraph width='md' margin={false} />
        </div>
    );
};

export const TemplateDos = () => {
    return (
        <div className='template2'>
            <CustomBoxTemplateGraph width='md' margin={true} />
            <CustomBoxTemplateGraph width='md' margin={true} />
            <CustomBoxTemplateGraph width='md' margin={true} />
            <CustomBoxTemplateGraph width='md' margin={true} />
        </div>
    );
};

export const TemplateTres = () => {
    return (
        <div className='template3'>
            <CustomBoxTemplateGraph width='lg' margin={true} />
            <CustomBoxTemplateGraph width='xs' margin={true} />
            <CustomBoxTemplateGraph width='xxs' margin={true} />
            <CustomBoxTemplateGraph width='xxs' margin={true} />
            <CustomBoxTemplateGraph width='xxs' margin={true} />
        </div>
    );
};

export const TemplateCuatro = () => {
    return (
        <div className='template4'>
            <CustomBoxTemplateGraph width='mini' margin={true} />
            <CustomBoxTemplateGraph width='tiny' margin={true} />
            <CustomBoxTemplateGraph width='sm' margin={true} />
            <CustomBoxTemplateGraph width='micro' margin={true} />
            <CustomBoxTemplateGraph width='nano' margin={true} />
            <CustomBoxTemplateGraph width='nano' margin={true} />
            <CustomBoxTemplateGraph width='nano' margin={true} />
        </div>
    );
};
